import { Navigate } from 'react-router-dom';

// project imports
import { useLandingRoute } from '../lib/useLandingRoute';

// ==============================|| LANDING REDIRECT (LAND-CFG) ||============================== //
// Açılış sayfası KİRACI AYARIDIR (marka `extras.landingPages`; seçenekler @zercode/tenancy
// LANDING_CATALOG'da). Bu bileşen hem `index` hem `*` catch-all için kullanılır — ikisi AYNI hedefe
// gitmeli, yoksa eskimiş bir derin bağlantı taze girişten farklı bir yere düşer.
//
// Çözüm `useLandingRoute`'ta; sol üstteki logo da AYNI hook'u okur (LogoSection), böylece "giriş"
// ile "logoya tıklama" tek bir hedefte buluşur.
//
// İZİNLER GELENE KADAR BEKLER: hook `null` derken ayarlanan sayfanın erişilebilirliği bilinmiyordur;
// o an varsayılana yönlendirmek yöneticinin ayarını rastgele yok saymak olurdu. Açılış tek seferlik
// ve çok kısa bir karar olduğu için beklemek en az kötü olan.

export default function LandingRedirect() {
  const target = useLandingRoute();

  if (!target) {
    return null;
  }

  return <Navigate to={target} replace />;
}
